function multiselectLastActive($element) {
    const $options = $element.next().find('.multiselect-container').children('li'),
        $notSelectedOptions = $options.filter(':not(.active)'),
        $selectedOptions = $options.filter('.active');

    $options.removeClass('is-last');

    if ($selectedOptions.length && $notSelectedOptions.length) {
        $selectedOptions.last().addClass('is-last');
    }
}

function buildFilterMultiselect(selector) {
    const $filterSelect = $(selector);

    initMultiselect({
        selector: selector,
        settings: {
            nonSelectedText: $filterSelect.attr('placeholder'),
            allSelectedText: $filterSelect.data('all-selected'),
            onDropdownShow: function() {
                if (!$filterSelect.hasClass('is-reordered')) {
                    const $multiselectContainer = $filterSelect.next().find('.multiselect-container');

                    $multiselectContainer.find('a').each(function (index) {
                        const id = $filterSelect.data('id') + index,
                            $input = $(this).find('input'),
                            $label = $(this).find('label');

                        $label.attr('for', id);
                        $input.attr('id', id);

                        $input.detach();
                        $input.prependTo($(this));

                        $(this).on('click', function (e) {
                            e.stopPropagation();
                        });
                    });
                }

                multiselectLastActive($filterSelect);

                $filterSelect.addClass('is-reordered');
            },
            onChange: function() {
                multiselectLastActive($filterSelect);
            }
        }
    });
}

$(function() {
    buildFilterMultiselect('.js-brands-filter-select');
    buildFilterMultiselect('.js-categories-filter-select');
});